module.exports = __webpack_public_path__ + "img/default_avatar.d59cb596.jpg";